import { Evented } from '../core/Evented';
import Map from '../shim/Map';
/**
 * Enum to identify the type of event.
 * Listening to 'Projector' will notify when projector is created or updated
 * Listening to 'Widget' will notify when widget root is created or updated
 */
export var NodeEventType;
(function (NodeEventType) {
    NodeEventType["Projector"] = "Projector";
    NodeEventType["Widget"] = "Widget";
})(NodeEventType || (NodeEventType = {}));
export class NodeHandler extends Evented {
    constructor() {
        super(...arguments);
        this._nodeMap = new Map();
    }
    get(key) {
        return this._nodeMap.get(key);
    }
    has(key) {
        return this._nodeMap.has(key);
    }
    add(element, key) {
        this._nodeMap.set(key, element);
        this.emit({ type: `${key}` });
    }
    addRoot() {
        this.emit({ type: NodeEventType.Widget });
    }
    remove(key) {
        this._nodeMap.delete(key);
    }
    addProjector() {
        this.emit({ type: NodeEventType.Projector });
    }
    clear() {
        this._nodeMap.clear();
    }
}
export default NodeHandler;
//# sourceMappingURL=NodeHandler.mjs.map